import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Features from './components/Features';
import Workflow from './components/Workflow';
import Testimonials from './components/Testimonials';
import Benefits from './components/Benefits';
import Contact from './components/Contact';
import Footer from './components/Footer';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Cookies from './pages/Cookies';
import ScrollToTop from './components/ScrollToTop';
import './styles/animations.css';

function App() {
  useEffect(() => {
    window.scrollTo(0, 0);

    document.title = 'SmartiStat - Environmental Monitoring Solutions';
    
    const handleSmoothScroll = (e: MouseEvent) => {
      const target = e.target as HTMLAnchorElement;
      if (target.tagName === 'A' && target.hash) {
        e.preventDefault();
        const element = document.querySelector(target.hash);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);
    
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fadeIn');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);
    
    const sections = document.querySelectorAll('section > div');
    sections.forEach(section => {
      section.classList.add('opacity-0');
      observer.observe(section);
    });
    
    return () => {
      document.removeEventListener('click', handleSmoothScroll);
      sections.forEach(section => {
        observer.unobserve(section);
      });
    };
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/" element={(
          <div className="relative min-h-screen bg-white font-sans antialiased">
            <Navbar />
            <main className="flex-1">
              <Hero />
              <Features />
              <Workflow />
              <Testimonials />
              <Benefits />
              <Contact />
            </main>
            <Footer />
            <ScrollToTop />
          </div>
        )} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;